import { Flex, Spinner, Text, VStack } from '@chakra-ui/react';

export const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <Flex justify="center" align="center" minH="200px" w="full">
      <VStack spacing={4}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text color="gray.600">{message}</Text>
      </VStack>
    </Flex>
  );
};
